import * as React from 'react';
import * as url from 'url';
import { RendererComponentProps, ContextObserver } from '../../../webana';
import { observer } from 'mobx-react';
import { Subscriber } from 'react-broadcast';
import {
  DataSource,
  DataSourceOperation
} from '../../../store/DataSourceProvider';
import { Button } from 'antd';
import { AuthSession } from '../../../store/AuthSession';
import * as moment from 'moment';

interface PDFBatchButtonComponentConfig {}

interface PDFBatchItem {
  [key: string]: string;
  id: string;
  name: string;
}

interface PDFBatchButtonComponentState {
  loading?: boolean;
  error?: Error;
  urlPath?: string;
  // employeesAssignments: { [key: string]: string[] };
  // employeesUnsaved: { [key: string]: { employees: string[]; crew: any } };
  // employeesSaving: { [key: string]: boolean };
}

@observer
export class PDFBatchButtonComponent extends React.Component<
  RendererComponentProps<PDFBatchButtonComponentConfig> & ContextObserver<any>,
  PDFBatchButtonComponentState
> {
  state = {
    loading: undefined,
    error: undefined,
    urlPath: undefined
    // employeesAssignments: {},
    // employeesUnsaved: {},
    // employeesSaving: {}
  };

  getPDFBatchURL = async (items: PDFBatchItem[], dataSource: DataSource) => {
    const date = this.props.context.router.location.state.calendarDate;

    this.setState({ loading: true, urlPath: undefined, error: undefined });
    try {
      const res = await dataSource.send(
        DataSourceOperation.query,
        'getPDFBatch',
        ['urlPath'],
        {
          items,
          date: moment(date).format("YYYY-MM-DD")
        }
      );
      this.setState({ loading: false, urlPath: res.urlPath, error: undefined });
    } catch (err) {
      console.log(`failed to display PDF due to error: ${err.message}`);
      alert("Chyba - PDF se nepodařilo vygenerovat!");
      this.setState({ loading: false, urlPath: undefined, error: err });
    }
    // setTimeout(() => {
    //   this.setState({ loadingPDF: undefined });
    // }, 0);
  };

  startLoading = () => {
    const { context } = this.props;

    if (
      !this.state.loading &&
      !this.state.error &&
      !this.state.urlPath &&
      context.resources.plans &&
      context.resources.plans.data
    ) {
      const fn = () => {
        const ids = context.resources.plans.data.items.map((x: any) => ({
          id: x.iZakID,
          name: x.nsZakCislo
        }));
        this.getPDFBatchURL(ids, context.resources.plans.dataSource);
      };
      setTimeout(fn, 0);
    }
  };

  // componentDidUpdate() {
  //   console.log('did update');
  //   this.startLoading();
  // }

  // componentDidMount() {
  //   console.log('did mount');
  //   this.startLoading();
  // }

  loadingElement(): React.ReactNode {
    return (
      <Button icon="loading" disabled={true}>
        Generuji PDF výstupy
      </Button>
    );
  }

  downloadElement(): React.ReactNode {
    return (
      <Button icon="download" onClick={this.proceedToDownload}>
        Stáhnout
      </Button>
    );
  }

  proceedToDownload = () => {
    const { context } = this.props;

    let urlPath: any = this.state.urlPath;
    if (!urlPath) {
      console.log(`could not download path ${urlPath}`);
      return;
    }

    if (urlPath[0] === '/') {
      urlPath = urlPath.substr(1);
    }
    window.open(
      url.resolve(context.resources.plans.dataSource.url, urlPath) +
        `?access_token=${AuthSession.current().accessToken}`,
      '_blank'
    );
  };

  render() {
    this.startLoading();
    return this.state.loading || typeof this.state.loading === 'undefined'
      ? this.loadingElement()
      : this.downloadElement();
  }
}

export class PDFBatchButton extends React.Component<
  RendererComponentProps<PDFBatchButtonComponentConfig>
> {
  render() {
    return (
      <Subscriber channel="context">
        {ctx => <PDFBatchButtonComponent {...this.props} context={ctx} />}
      </Subscriber>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/sezako/components/PDFBatchButton.tsx